import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ActionsBar from './ActionsBar';

import { addReclamationObservateur } from 'store/reclamation/detailsActions';
import { removeReclamationObservateur } from 'store/reclamation/detailsActions';
import { openAddMemoDialog } from 'store/common/commonActions';
import { openAddQuestionDialog } from 'store/common/commonActions';
import { openAffectationDialog } from 'store/common/commonActions';
import { openClotureDialog } from 'store/common/commonActions';
import { openAnnulerClotureDialog } from 'store/common/commonActions';
import { openAddReclamationDialog } from 'store/common/commonActions';


import withLoader from 'components/Shared/withLoader';

const ActionsBarWithLoader = withLoader(ActionsBar);

class ActionsBarContainer extends React.Component {

    handleObservateurClick = () => {
        let utilisateurId = JSON.parse(localStorage.getItem('utilisateur')).id;

        if (this.props.reclamation.isObservateur)
            this.props.removeObservateur(this.props.reclamation.id, utilisateurId);
        else
            this.props.addObservateur(this.props.reclamation.id, utilisateurId);
    }

    handleClickAddMemo = () => {
        // On change le state de l'appli
        this.props.openAddMemoDialog(this.props.reclamation.id);
    };

    handleClickAddQuestion = () => {
        // On change le state de l'appli
        this.props.openAddQuestionDialog(this.props.reclamation.id);
    };

    handleClickAffectation = () => {
        // On change le state de l'appli

        console.log("handleClickAffectation", this.props.reclamation);

        if(this.props.reclamation !== null && this.props.reclamation.id !== 0)
        {
            this.props.openAffectationDialog(this.props.reclamation.id);
        }
    };

    handleClickCloturer = () => {
        // On change le state de l'appli
        //console.log("handleClickCloturer");
        this.props.openClotureDialog(this.props.reclamation.id);
    };

    handleClickAnnulerCloture = () => {
        // On change le state de l'appli
        this.props.openAnnulerClotureDialog(this.props.reclamation.id);
    };

    handleClickReclamationLiee = () => {
        // On Change le state de l'application.
        this.props.openAddReclamationDialog(true, this.props.reclamation.id);
    }

    render() {

        const { reclamation, utilisateurCourant, isLoading } = this.props;

        if (!reclamation || reclamation.id === 0) {
            return null;
        }


        // RECLA-715
        // Le bouton question-réponse est desactivé lorsqu'un est soit même l'émetteur
        let questionDisabled = "";
        if (reclamation.emetteur.id === utilisateurCourant.id) {

            if (!reclamation.affectationUtilisateur) {
                questionDisabled = "Ce dossier après-vente n'a pas encore été affecté, votre message sera sans suite.";
            }
            else {
                if (reclamation.affectationUtilisateur.id === utilisateurCourant.id) {
                    questionDisabled = "Ce dossier après-vente vous est affecté, votre message sera sans suite.";
                }
            }
        }

        // RECLA-715
        // Les boutons question-réponse et mémo sont desactivés lorsqu'il y a au moins une action demandant réponse sans réponse
        let memoDisabled = "";
        if (reclamation.nbActionsSansReponse > 0) {

            questionDisabled = "Consulter l'historique du dossier après-vente, une réponse n'a pas encore été donnée.";

            if (!utilisateurCourant.autoriseMemo) {
                memoDisabled = "Consulter l'historique du dossier après-vente, une réponse n'a pas encore été donnée.";
            }
        }

        return (
            <ActionsBarWithLoader
                isLoading={isLoading}
                reclamation={this.props.reclamation}
                onObservateurClick={this.handleObservateurClick}
                onClickAddMemo={this.handleClickAddMemo}
                onClickAddQuestion={this.handleClickAddQuestion}
                onClickAffectation={this.handleClickAffectation}
                onClickCloturer={this.handleClickCloturer}
                onClickAnnulerCloture={this.handleClickAnnulerCloture}
                onClickReclamationLiee={this.handleClickReclamationLiee}

                questionDisabled={questionDisabled}
                memoDisabled={memoDisabled}
            />
        );
    }
}

ActionsBarContainer.protoTypes = {
    reclamation: PropTypes.object.isRequired
};


const mapStateToProps = (state, props) => (
    {
        utilisateurCourant: JSON.parse(localStorage.getItem('utilisateur')), 
        isLoading: state.reclamation.details.isLoading
    }
);

const mapDispatchToProps = dispatch => ({
    addObservateur: (reclamationId, utilisateurId) => dispatch(addReclamationObservateur(reclamationId, utilisateurId)),
    openAddMemoDialog: (reclamationId) => dispatch(openAddMemoDialog(reclamationId)),
    openAddQuestionDialog: (reclamationId) => dispatch(openAddQuestionDialog(reclamationId)),
    openAffectationDialog: (reclamationId) => dispatch(openAffectationDialog(reclamationId)),
    openClotureDialog: (reclamationId) => dispatch(openClotureDialog(reclamationId)),
    openAnnulerClotureDialog: (reclamationId) => dispatch(openAnnulerClotureDialog(reclamationId)),
    removeObservateur: (reclamationId, utilisateurId) => dispatch(removeReclamationObservateur(reclamationId, utilisateurId)),
    openAddReclamationDialog: (reclamationLiee, reclamationId) => dispatch(openAddReclamationDialog(reclamationLiee, reclamationId, null))
});

export default connect(mapStateToProps, mapDispatchToProps)(ActionsBarContainer);